<!-- 分享活动页面 -->
<template>
    <div id="inviteFriends" ref="inviteFriends" class="right-body inviteFriends-right-body" >
        <el-scrollbar style='height:100%;'>
        <div class="inviteFriends-title">
            <div class="inviteFriends-center">
                <p>
                    {{$t('language.inviteFriends.titleBefor')}}
                    <span v-if="$i18n.locale == 'france'" style='color:#5065BC;white-space: nowrap;'>2 Go</span>
                    <span v-else style='color:#5065BC;white-space: nowrap;'>2 GB</span>
                    {{$t('language.inviteFriends.titleAfter')}}
                </p>
            </div>
        </div>
        <div class="inviteFriends-line"></div>
        <div class="inviteFriends-boby">
            <div class="inviteFriends-center">
                <div class="if_emailPic">
                    <div v-if="$i18n.locale == 'france'">
                        <span class="inviteFriends-france-emailPic" style="margin-right: 40px;">2Go</span>
                        <span class="inviteFriends-france-emailPic" style="margin-right: 85px;">2Go</span>
                    </div>
                    <div v-else>
                        <span class="inviteFriends-france-emailPic" style="margin-right: 40px;">2GB</span>
                        <span class="inviteFriends-france-emailPic" style="margin-right: 85px;">2GB</span>
                    </div>
                </div>
                <div>{{$t('language.inviteFriends.shareEmailTitle')}}</div>
                <div class="inviteFriends-block">
                    <tags-input v-model='email' class="inviteFriends-email-tags" :message="$t('language.inviteFriends.emailTip')" :type="'invite'" />
                    <button class="inviteFriends-email-button" @click="shareSendEmail()" v-loading="loadingEmail">{{$t('language.inviteFriends.emailSend')}}</button>
                </div>
                <div class="inviteFriends-block">
                    <div class="inviteFriends-share-title">{{$t('language.inviteFriends.shareLinkTitle')}}</div>
                    <div class="sns-icon facebook inviteFriends-share-icon" :title="$t('language.popup.cloudExploerPopup.shareOnFacebook')" @click="share($event)"></div>
                    <div class="sns-icon twitter inviteFriends-share-icon" :title="$t('language.popup.cloudExploerPopup.shareOnTwitter')" @click="share($event)"></div>
                    <div class="sns-icon tumblr inviteFriends-share-icon" :title="$t('language.popup.cloudExploerPopup.shareOnTumblr')" @click="share($event)"></div>
                    <div class="sns-icon pinterest inviteFriends-share-icon" :title="$t('language.popup.cloudExploerPopup.shareOnPinterest')" @click="share($event)"></div>
                    <div class="sns-icon ins inviteFriends-share-icon" :title="$t('language.popup.cloudExploerPopup.shareOnLinkedIn')" @click="share($event)"></div>
                    <button class="inviteFriends-share-button" :title="'Copy invite link'" @click="copySite()">{{$t('language.common.copyLink')}}</button>
                </div>
                <div class="msg-loading" v-loading="loadingMsg">
                    <div class="inviteFriends-msg" v-show="user.payLevel!=1">
                        {{$t('language.inviteFriends.wonMonthFlows')}}
                        <span style='color:#5065BC;font-size:28px;white-space: nowrap;'>{{flow+" GB"}}</span>
                    </div>
                    <div class="if_bg inviteFriends-block" style="margin-top: 0.2rem;">
                        <div class="inviteFriends-showcase-title"><div style="max-width: 92%;">{{$t('language.inviteFriends.wonMonthTitle')}}</div></div>
                        <div class="inviteFriends-showcase-boby">
                            <div class="inviteFriends-showcase_tab">
                                <div class="inviteFriends-showcase_tab_title">{{$t('language.inviteFriends.lastWinner')+" ("+awardee.oldMouth+" "+awardee.oldYear+")"}}</div>
                                <div class="inviteFriends-showcase_tab_msg" style="font-size: 14px;">
                                    <div style="width: 30%;"><div class="wonner-email" title="awardee.awardeeEmail">[{{awardee.awardeeEmail}}</div>]</div>
                                    <div style="width: 25%;color:#5065BC;font-weight: 700;">{{$t('language.inviteFriends.winnerInvites',{"num" :awardee.inviteSucNum})}}</div>
                                    <div style="width: 45%;float: right;">{{$t('language.inviteFriends.winnerTip')}}</div>
                                </div>
                            </div>
                            <div class="inviteFriends-showcase_tab">
                                <div class="inviteFriends-showcase_tab_title">{{$t('language.inviteFriends.statusTitle')}}</div>
                                <div class="inviteFriends-showcase_tab_msg">
                                    <div style="width: 55%;">{{$t('language.inviteFriends.successInvites')+userInviteSucNum}}</div>
                                    <div style="width: 45%;">{{$t('language.inviteFriends.chanceWin')}}<span style='color:#5065BC;font-weight: 700;'>{{userWeight}} </span><span>{{"/ "+allWeight}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                <div class="inviteFriends-block inviteFriends-tips">
                    <p class="inviteFriends-tips-title">{{$t('language.inviteFriends.tipsTitle')}}</p>
                    <div class="inviteFriends-tips-msg">1.<span>{{$t('language.inviteFriends.tipsOne')}}</span></div>
                    <div class="inviteFriends-tips-msg">2.<span>{{$t('language.inviteFriends.tipsTwo')}}</span></div>
                    <div class="inviteFriends-tips-msg">3.<span>{{$t('language.inviteFriends.tipsThird')}}</span></div>
                </div>
            </div>
        </div>
        </el-scrollbar>
    </div>
</template>
<script>
  import commonstate from '@/js/constant.js';
  import tagsInput from '@/components/common/input/tag_input';
  import commonUtils from "@/js/workspace/common_util.js";

    const INVITE_URL = commonstate.inviteFriendsUrl;

  export default {
    components: {
      tagsInput
    },
    data: function () {
      return {
          user: commonstate.user,
          email: [],
          loadingEmail: false,
          linkUrl: "",
          flow: 0,//本月流量
          userInviteSucNum: 0,//本月用户成功邀请数
          userWeight: 0,//本月用户权重
          allWeight: 0,//本月全部权重
          awardee: {},//上月获奖人信息,inviteSucNum获奖人邀请成功次数,awardeeEmail获奖人加密邮箱
          testUserId: "",//测试用userId
          loadingMsg: false,
      };
    },
    created() {
        //获取页面数据
        this.$nextTick(()=>{
            this.user = commonstate.user
            let lang = commonUtils.caseIndexLanguage(this.$i18n.locale);
            //pt默认en
            lang = lang == 'pt'?'en':lang;
            this.linkUrl = commonstate.oldVersionUrl+ (lang == 'en'?'':'/'+lang)+INVITE_URL+commonstate.user.id;
            this.getInformation();
        })
    },
    methods: {
        getInformation(){
            let data = {ud: commonstate.user.id,}
            this.loadingMsg = true;
            this.Utils.doInviteFriendsRequest("get_information", data).then(res => {
                this.loadingMsg = false;
                if (res.result){
                    let pif = res.result;
                    this.flow = pif.flow;
                    this.userInviteSucNum = pif.userInviteSucNum;
                    this.userWeight = pif.userWeight;
                    this.allWeight = pif.allWeight;
                    this.awardee = pif.awardee;
                }else {
                    this.$toast({
                        text: res.reason?this.$t('language.exception.' + res.reason):res.msg,
                        type: 'fail',
                        idValue: "inviteFriends"
                    });
                }
            })
        },
        share(e) {
            let classList = e.target.classList
            let shareUrl = encodeURIComponent(this.linkUrl)
            let shareText = encodeURIComponent(this.$t('language.inviteFriends.shareText'));
            //mc的logo静态地址
            let sharePic = encodeURIComponent(`${commonstate.nowNewUrl}/static/mc-logo.png`);
            let url
            if (classList.contains("facebook")) {
                url = `https://www.facebook.com/dialog/share?app_id=1181798628562318&href=${shareUrl}&title=${shareText}`
            } else if (classList.contains("twitter")) {
                url = `https://twitter.com/share?url=${shareUrl}&text=${shareText}&via=multcloud`
            } else if (classList.contains("tumblr")) {
                url = `https://www.tumblr.com/widgets/share/tool?shareSource=legacy&canonicalUrl=&url=${shareUrl}&title=${shareText}`
            } else if (classList.contains("ins")) {
                url = `https://www.linkedin.com/shareArticle/?mini=true&title=${shareText}&url=${shareUrl}`
            } else {
                url = `https://www.pinterest.com/pin/create/button/?url=${shareUrl}&description=${shareText}&media=${sharePic}`
            }
            window.open(url, 'top')
        },
        shareSendEmail() {
            if(this.loadingEmail){return}
            if(this.email.length>0) {
                //邮箱验证
                let regEmail =commonstate.emailpattern;
                let sendEmails = "";//可以发送的邮箱
                let errorEmails = [];//验证失败的邮箱
                this.email.forEach(function(e,index){
                    if(regEmail.test(e.email.trim())){
                        sendEmails += e.email+",";
                    }else {
                        e.status = 'error';
                        errorEmails.push(e);
                    }
                })
                if(sendEmails.length<1){
                    this.$toast({
                        text: this.$t('language.popup.cloudExploerPopup.emailSentNotice'),
                        type: "notice",
                        idValue: "inviteFriends"
                    });
                    return false
                }
                let shareEmail = {
                    ud: commonstate.user.id,
                    shareUrl: this.linkUrl,
                    emails: sendEmails
                }
                this.loadingEmail = true;
                this.Utils.doEmailRequest("send_invite_friends", shareEmail).then(res => {
                    if (res.message === 'success'){
                        this.$toast({
                            text: this.$t('language.popup.cloudExploerPopup.emailSentSuccessful'),
                            type: "success",
                            idValue: "inviteFriends"
                        });
                    }else{
                        this.$toast({
                            text: this.$t('language.popup.cloudExploerPopup.emailSentNotice'),
                            type: "notice",
                            idValue: "inviteFriends"
                        });
                    }
                    //刷新当前收件人为为符合正则的邮箱，并且背景色变红
                    if(errorEmails.length>0){
                        this.email = errorEmails;
                    }else{
                        //全部发送则重置页面
                        this.email = [];
                    }
                    this.loadingEmail = false;
                })
            }else {
                this.$toast({
                    text: this.$t('language.popup.cloudExploerPopup.emailSentNull'),
                    type: "notice",
                    idValue: "inviteFriends"
                });
            }
        },
        copySite() {
            let data = this.linkUrl;
            let oInput = document.createElement('input');
            oInput.value = data;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$toast({
                text: this.$t('language.popup.cloudExploerPopup.linkCopySuccessful'),
                type: 'success',
                idValue: "inviteFriends",
            });
            oInput.remove()
        },
    }
  }
</script>
<style>
.inviteFriends-line {
    width: 85%;
    height: 2px;
    /*no*/
    margin: 0 auto;
    background: #F0F3FC;
}

.inviteFriends-right-body {
    background-color: unset !important;
}

.inviteFriends-title {
    overflow: hidden;
    text-align: center;
}

.inviteFriends-title p{
    font-size: 28px;/*no*/
    font-weight: 700;
}

.inviteFriends-boby {
    text-align: center;
}

.inviteFriends-center {
    display: inline-block;
    width:700px;/*no*/
}

.inviteFriends-boby .inviteFriends-center {
    text-align: left;
}

.inviteFriends-share-icon {
    float: left;
    margin-left: 10px; /*no*/
    margin-right: 10px; /*no*/
}

.inviteFriends-share-title {
    float:left;
    height:30px;/*no*/
    line-height:30px;/*no*/
    margin-right: 0.1rem;
}

.inviteFriends-share-button {
    border: 1px solid #7080C6;/*no*/
    background-color: #FFFFFF;
    color: #7080C6;
    margin-left: 0.1rem;
    width: 125px;/*no*/
}

.inviteFriends-share-button:hover {
    background-color: #FFFFFF;
}
.inviteFriends-block {
    overflow: hidden;
}

.inviteFriends-msg {
    margin-top: 0.3rem;
    font-size: 22px;/*no*/
    font-weight: 700;
}

.inviteFriends-showcase-title {
    height: 52px;/*no*/
    color:#5065BC;
    font-size:18px;/*no*/
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
}

.inviteFriends-showcase-boby {
    height: 158px;/*no*/
    margin-left: 155px;/*no*/
    text-align: left;
}
.inviteFriends-showcase_tab {
    height: 79px;/*no*/
}

.inviteFriends-showcase_tab_title {
    padding-top: 16px;/*no*/
    font-size: 18px;/*no*/
    padding-bottom: 5px;/*no*/
}

.inviteFriends-showcase_tab_msg {
    font-size: 14px;/*no*/
}

.inviteFriends-showcase_tab_msg div {
    float: left;
}

.inviteFriends-showcase_tab_msg .wonner-email{
    max-width: 95%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.inviteFriends-tips-title{
    font-size: 22px;/*no*/
    font-weight: 700;
    margin-bottom:5px;/*no*/
}

.inviteFriends-tips-msg{
    line-height: 25px;/*no*/
}

.inviteFriends-tips-msg span{
    float: right;
    width: 685px;/*no*/
}

.inviteFriends-tips div {
    float: left;
}

.inviteFriends-tips{
    margin-bottom: 20px;/*no*/
}

.inviteFriends-email-tags {
    width:73%;
    float:left;
    margin-top: 0.15rem;
    margin-bottom: 0.15rem;
}

.inviteFriends-email-button {
    width:20%;
    float:right;
    margin-top: 0.15rem;
    margin-right: 0.1rem;
    margin-bottom: 0.15rem;
    height:34px;/*no*/
}

#inviteFriends .muli-tags input {
    height: 30px !important; 
    width: 210px !important;
}

#inviteFriends .muli-tags .textbg {
    left: auto;
    top: auto;
    margin: 0.07rem;
}

#inviteFriends .msg-loading .el-loading-mask {
    background-color: #fff;
    z-index: 0;
    top: 0;
}

#inviteFriends .msg-loading .el-loading-spinner{
    margin-top: 0;
    top: 40%;
}

#inviteFriends .msg-loading .el-loading-spinner .circular {
    height: 50px !important;
    /*no*/
    width: 50px !important;
    /*no*/
}

#inviteFriends .inviteFriends-email-button .el-loading-mask {
    background-color: #5166BD;
    z-index: 0;
    top: 0;
}

#inviteFriends .inviteFriends-email-button .el-loading-spinner{
    margin-top: 0;
    top: 12%;
}

#inviteFriends .inviteFriends-email-button .el-loading-spinner .circular {
    height: 25px !important;
    /*no*/
    width: 25px !important;
    /*no*/
}

#inviteFriends .inviteFriends-email-button .el-loading-spinner .path {
    stroke: #ffffff!important;
    stroke-width: 3;
}

#inviteFriends::-webkit-scrollbar{
    width: 8px;
    /*no*/
    height: 10Px;
    /* 给滚动条一个最小的高度 */
    background-color: #fff;
}

#inviteFriends::-webkit-scrollbar-thumb{
    min-height: 40px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.inviteFriends-france-emailPic {
    float: right;
    margin-top: 27px;
    font-size: 24px;/*no*/
    font-weight: 700;
    color: rgb(80, 101, 188);
    width: 0.45rem;
    background-color: #D6E3FD;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/inviteFriends.vue